import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {GetService} from "@shared/api/services/get.service";

@Injectable()
export class CrudService<TList, TGet, TCreate, TUpdate> extends GetService<TList, TGet> {
    create(data: Partial<TCreate>): Observable<any> {
        return this.http.post<any>(this.urlToEntity, data)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
    }
    update(id: number, data: Partial<TUpdate>): Observable<any> {
        return this.http.put<any>(this.urlToEntity + '/' + id, data)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(this.urlToEntity + '/' + id)
    }
}
